// extracted by mini-css-extract-plugin
module.exports = {"Panoramic":"Panoramic_Panoramic__cLFE8","ripple-spread":"Panoramic_ripple-spread__hxOQZ","updown":"Panoramic_updown__jZTZu"};